import { SetStateAction } from 'react';

import axios from 'axios';
import Services from './index.service';
import { IRequestConfig, MethodsTypes } from 'models/Axios';

export default class UploadService extends Services<any, any> {
  public async upload(file: any) {
    const formData = new FormData();
    formData.append('file', file);

    return await axios
      .post(`${this.base_url}/files/upload`, formData, {
        headers: {
          Authorization: `Bearer ${this.access_token()}`,
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((result) => result.data.data)
      .catch((err) => {
        return;
      });
  }

  public async uploadLegalDocument(data: any) {
    const formData = new FormData();
    formData.append("customerId", data.customerId.trim());
    formData.append("brandId", data.brandId);
    formData.append("buId", data.buId);
    formData.append("userType", data.userType);

    data.files.forEach((element: any, index: any) => {
      formData.append(`files[${index}].file`, element.file);
      formData.append(`files[${index}].legalDocumentType`, element.legalDocumentType);
      formData.append(`files[${index}].nameDocument`, element.nameDocument);
    });

    const config: IRequestConfig<any> = {
      url: `${this.base_url}/express-upload/upload-legaldocument`,
      method: MethodsTypes.post,
      data: formData,
      headers: {
        "Content-Type": 'multipart/form-data',
        Authorization: `Bearer ${this.access_token()}`,
      }
    };

    return axios(config)
      .then((result) => result)
      .catch((error) => {
        return error.response;
      });
  }
}